import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionTypes } from "../constants/action-types";
import { apiCall } from "../../api/api";
import axios from "axios";

export const createLabourAndPacking = createAsyncThunk(
  ActionTypes.CREATE_LABOUR_AND_PACKING,
  async (sendData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        'labour-and-packing/create',
        'post',
        sendData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateLabourAndPacking = createAsyncThunk(
  ActionTypes.UPDATE_LABOUR_AND_PACKING,
  async (sendData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        'labour-and-packing/update',
        'patch',
        sendData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getLabourAndPacking = createAsyncThunk(
  ActionTypes.GET_LABOUR_AND_PACKING,
  async (canonicalId: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `labour-and-packing/${canonicalId}`,
        "get",
        canonicalId
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);